import React from 'react';
import { Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer style={{ backgroundColor: '#0a0a0a' }}>
      <div className="container mx-auto px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="text-sm tracking-[0.3em] font-light mb-6" style={{ color: '#ffffff' }}>
              FARZEEN
            </h3>
            <p className="text-sm font-light leading-relaxed mb-6" style={{ color: 'rgba(255,255,255,0.5)' }}>
              Empowering women to break free and build freedom-based businesses through digital marketing and personal branding.
            </p>
            <a 
              href="https://instagram.com/itsfarzeenkhan" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-xs tracking-[0.15em] transition-opacity hover:opacity-60"
              style={{ color: '#8b7355' }}
            >
              <Instagram size={16} strokeWidth={1.5} />
              FOLLOW ON INSTAGRAM
            </a>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="text-xs tracking-[0.2em] font-light mb-6" style={{ color: '#8b7355' }}>
              QUICK LINKS
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#about" className="text-sm font-light transition-opacity hover:opacity-60" style={{ color: 'rgba(255,255,255,0.5)' }}>
                  About
                </a>
              </li>
              <li>
                <a href="/dwa" className="text-sm font-light transition-opacity hover:opacity-60" style={{ color: 'rgba(255,255,255,0.5)' }}>
                  Digital Wealth Academy
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm font-light transition-opacity hover:opacity-60" style={{ color: 'rgba(255,255,255,0.5)' }}>
                  Services
                </a>
              </li>
              <li>
                <a href="#testimonials" className="text-sm font-light transition-opacity hover:opacity-60" style={{ color: 'rgba(255,255,255,0.5)' }}>
                  Success Stories
                </a>
              </li>
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h4 className="text-xs tracking-[0.2em] font-light mb-6" style={{ color: '#8b7355' }}>
              GET IN TOUCH
            </h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href="https://stan.store/FarzeenDigitalWealth/p/lets-chat-book-your-free-15-min-clarity-call" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm font-light transition-opacity hover:opacity-60" 
                  style={{ color: 'rgba(255,255,255,0.5)' }}
                >
                  Book a Call
                </a>
              </li>
              <li>
                <a 
                  href="https://instagram.com/itsfarzeenkhan" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm font-light transition-opacity hover:opacity-60" 
                  style={{ color: 'rgba(255,255,255,0.5)' }}
                >
                  Instagram DM
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="pt-8 border-t" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs font-light" style={{ color: 'rgba(255,255,255,0.3)' }}>
              © {new Date().getFullYear()} Farzeen Digital Wealth. All rights reserved.
            </p>
            <p className="text-xs font-light" style={{ color: 'rgba(255,255,255,0.3)' }}>
              Built with purpose. Designed for freedom.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
